import React, { useState } from "react";
import "./MobileFilters.css";

const filterData = {
  Category: ["Rings", "Necklaces", "Earrings", "Bracelets"],
  Price: ["Below ₹5,000", "₹5,000 - ₹10,000", "Above ₹10,000"],
  Material: ["Gold", "Silver", "Platinum"],
  Metal: ["Rose Gold", "Yellow Gold", "White Gold"]
};

const MobileFilters = ({ onClose, onApply }) => {
  const [selectedCategory, setSelectedCategory] = useState("Category");
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleCheckboxChange = (category, option) => {
    setSelectedFilters(prev => ({
      ...prev,
      [category]: prev[category]?.includes(option)
        ? prev[category].filter(item => item !== option)
        : [...(prev[category] || []), option]
    }));
  };

  return (
    <div className="mobile-filter-modal">
      <div className="filter-header">
        <span>Filters</span>
        <button className="close-btn" onClick={onClose}>✖</button>
      </div>

      <div className="filter-body">
        {/* Left Side */}
        <div className="filter-left">
          {Object.keys(filterData).map(cat => (
            <div
              key={cat}
              className={`filter-tab ${selectedCategory === cat ? "active" : ""}`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat}
            </div>
          ))}
        </div>

        {/* Right Side */}
        <div className="filter-right">
          {filterData[selectedCategory]?.map(option => (
            <label key={option} className="checkbox-label">
              <input
                type="checkbox"
                checked={selectedFilters[selectedCategory]?.includes(option) || false}
                onChange={() => handleCheckboxChange(selectedCategory, option)}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      <div className="filter-footer">
        <button className="apply-btn" onClick={() => onApply(selectedFilters)}>
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default MobileFilters;
